import { render, staticRenderFns } from "./CarChooseDownList.vue?vue&type=template&id=523ace15&"
import script from "./CarChooseDownList.vue?vue&type=script&lang=js&"
export * from "./CarChooseDownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports